// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0a28decb","453":"facd1ebd","667":"a5173bef"}[chunkId] + ".chunk.js";
};